import type { FaireProductEntity } from "../../entity_types/product";

export const p_497atqz5h5: FaireProductEntity = {
  token: "p_497atqz5h5",
  type: "product",
  name: "Vintage Large Oval Locket Necklace",
  brandToken: "b_2yc6uznjzg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/730789c5559e9e3444c858383aab26e85f9a255c49e26b598d45e5b96627ee11.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4d079ac9bccac289dd5413b15f5d87ae13c95282ac6a2447a34ec6849eb34555.jpeg",
    "https://cdn.faire.com/fastly/cf600a75df4f3ee9152c42efec6ea2192b631d9c48da3001c2636c5454043022.jpeg",
    "https://cdn.faire.com/fastly/9fca1fc3563af3e6fa65865c0e48d79092e1b2216a45a5c47ed3093b8ede7b25.jpeg",
  ],
  priceDollars: 29.1,
  description:
    'Deadstock vintage large brass oval locket charm with decorative filigree stamping, on a high-quality delicate 18" gold vermeil cable chain (2X industry standard gold-plating on 100% recycled sterling silver).\n\nAll materials are sustainable, eco-friendly, and ethically sourced. Vintage charms may have some signs of wear, but that\'s just what gives them character :)\n\n18" length chain\n29 x 23 mm',
  tags: [],
  msrpDollars: 58.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:23.598Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
